import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'CONFIGS_GET',
  GET_SUCCESS: 'CONFIGS_GET_SUCCESS',
  GET_FAILURE: 'CONFIGS_GET_FAILURE',
};

export const get = actions.get(key => `${BASE_URL}/configs/${key}`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});
